import { render, staticRenderFns } from "./ztptDetails.vue?vue&type=template&id=7063b354&scoped=true&"
import script from "./ztptDetails.vue?vue&type=script&lang=js&"
export * from "./ztptDetails.vue?vue&type=script&lang=js&"
import style0 from "./ztptDetails.vue?vue&type=style&index=0&id=7063b354&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063b354",
  null
  
)

export default component.exports